import { Platform } from "react-native"
import { Defs, Stop, Svg, RadialGradient as SVGRadialGradient, Circle } from "react-native-svg"

export function Bubble(props: { color: string; innerColor: string; x: number; y: number }) {
  return (
    <Svg
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      style={{
        position: "absolute",
        minHeight: Platform.OS === "web" ? "100svh" : 900,
        width: "100%",
      }}
    >
      <Defs>
        <SVGRadialGradient id="grad" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
          <Stop stopColor={"#efe7de"} offset={0} stopOpacity={0.4} />
          <Stop stopColor={props.innerColor} offset={0.8} stopOpacity={0.4} />
          <Stop stopColor={props.color} offset={0.9} stopOpacity={0.4} />
          <Stop stopColor={"#efe7de"} offset={1} stopOpacity={0} />
        </SVGRadialGradient>
      </Defs>
      <Circle cx={`${props.x}`} cy={`${props.y}`} r="350" fill="url(#grad)" />
    </Svg>
  )
}
